<template>
    <form @submit.prevent="handleSubmit">
        <div id="content-to-pdf" class="pdf-container web-container-mode" ref="contractContent">
            <div class="page">
                <!-- Contenido de la primera página aquí -->
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-3" style="padding-left: 10px;">
                            <img width="100" height="51" src="/img/LOGOTIPOGOLDERGFUND.jpg" />
                        </div>
                        <div class="col-6 form-header-cover">
                            <div class="form-group row">
                                <label for="numContract" class="col-form-label label-form-cover">Número de contrato:</label>
                                <div>
                                    <input type="text" class="form-control underline-input-cover" :value="store.form.products?.productContract?.referenceNumber"  disabled/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="numAcredit" class="col-form-label label-form-cover">Número de Acreditado: </label>
                                <div>
                                    <input type="text" class="form-control underline-input-cover" :value="store.form.prospects?.referenceNumber" disabled />
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="numAcredit" class="col-form-label label-form-cover">Lugar y Fecha:</label>
                                <div>
                                    <input type="text" class="form-control underline-input-cover" />
                                </div>
                                <div class="ml-2">
                                    <input type="date" class="form-control underline-input-cover" />
                                </div>
                            </div>
                        </div>
                        <div class="col-3 text-right">
                            <p>Anexo “A”</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 title-anexo-cover">
                            <p>CARÁTULA DEL CONTRATO</p>
                        </div>
                        <div class="col-6"></div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table-cover web-mode" cellspacing="0">
                                <tr style="height:12pt">
                                    <td style="width:268pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s1"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Nombre del Producto<span style=" color: #000;">:</span> <span class="s2">{{
                                                store.form.products?.description || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:264pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="3">
                                        <p class="s1"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Tipo de Producto<span style=" color: #000;">:</span> <span class="s2">{{
                                                store.form.products?.productType.name || '' }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:16pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s3"
                                            style="padding-top: 3pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            EL ACREDITANTE (GOLDBERGFUND): <span class="s2">KVF GROUP, S.A. DE
                                                C.V.</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:23pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Domicilio: <span class="s2">{{ store.form.branchOffices?.address || ''
                                                }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:15pt">
                                    <td style="width:268pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 3pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Representante Legal: <span class="s2">{{ store.form.branchOffices?.legalName
                                                || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:264pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="3">
                                        <p class="s2"
                                            style="padding-top: 3pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Poder Notarial Número y Fecha:
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:14pt">
                                    <td style="width:388pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="3">
                                        <p class="s3"
                                            style="padding-top: 2pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            EL ACREDITADO:
                                            <span class="s2">
                                                {{ nameAccredited || '' }}
                                            </span>
                                        </p>
                                    </td>
                                    <td style="width:144pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 2pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            RFC: <span class="s2">{{ store.form.prospects?.generalInformation?.rfc || ''
                                                }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            CURP: <span class="s2">{{ store.form.prospects?.generalInformation?.curp ||
                                                '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:399pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="4">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Fecha y Lugar de Nacimiento / No. y Fecha Acta Constitutiva:
                                            <span class="s2">
                                                {{ date_place_birth_num_date_institute || '' }}
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:313pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="3">
                                        <p class="s2"
                                            style="padding-top: 2pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Número y Nombre del Notario:
                                            <span class="s2">
                                                {{ store.form.prospects?.generalInformation?.notaryInformation || '' }}
                                            </span>
                                        </p>
                                    </td>
                                    <td style="width:219pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 2pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Folio y fecha Registro:
                                            <span class="s2">
                                                {{ 
                                                    `
                                                    ${store.form.prospects?.generalInformation?.fielFolio || '' }
                                                    ${store.form.prospects?.generalInformation?.dateOfIncorporation || ''}
                                                    `
                                                }}
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:313pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="3">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Correo Electrónico: <span class="s2">{{
                                                store.form.prospects?.generalInformation?.email || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:219pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Teléfono Fijo: <span class="s2">{{ store.form.prospects?.generalInformation?.homePhone || '' }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Celular: <span class="s2">{{ store.form.prospects?.generalInformation?.cellPhone || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:399pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="4">
                                        <p class="s2"
                                            style="padding-top: 2pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Nombre de Contacto:
                                            <span class="s2">
                                                {{ nameAccredited || '' }}
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:22pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s2"
                                            style="padding-top: 6pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Domicilio:
                                            <span class="s2">
                                                {{ 
                                                    `
                                                        ${store.form.prospects?.addressAccredited?.street || ''}
                                                        ${store.form.prospects?.addressAccredited?.exteriorNumber || ''}
                                                        ${store.form.prospects?.addressAccredited?.interiorNumber || ''}
                                                        ${store.form.prospects?.addressAccredited?.district || ''}
                                                    ` 
                                                }}
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:388pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="3">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Nombre del Representante Legal:
                                            <span class="s2">
                                                {{ store.form.prospects?.legalRepresentative?.firstName || '' }}
                                                {{ store.form.prospects?.legalRepresentative?.lastName || '' }}
                                                {{ store.form.prospects?.legalRepresentative?.mothersMaidenName || '' }}
                                            </span>
                                        </p>
                                    </td>
                                    <td style="width:144pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            RFC: <span class="s2">{{ store.form.prospects?.legalRepresentative?.rfc || '' }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            CURP: <span class="s2">{{ store.form.prospects?.legalRepresentative?.curp || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:180pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Teléfono:
                                            <span class="s2">
                                                {{
                                                    `
                                                    ${store.form.prospects?.legalRepresentative?.cellPhone || ''}
                                                    ${store.form.prospects?.legalRepresentative?.homePhone || ''}
                                                    ${store.form.prospects?.legalRepresentative?.officePhone || ''}
                                                    `
                                                }}
                                            </span>
                                        </p>
                                    </td>
                                    <td style="width:219pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Correo Electrónico: <span class="s2">{{store.form.prospects?.legalRepresentative?.email || '' }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            No. De Poder:
                                        </p>
                                    </td>
                                    <td style="width:180pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Fecha del Poder:
                                        </p>
                                    </td>
                                    <td style="width:219pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Folio y
                                            Fecha de Registro:</p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s2"
                                            style="padding-top: 2pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Número y
                                            Nombre del Notario:</p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:313pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="3">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Teléfono:
                                        </p>
                                    </td>
                                    <td style="width:219pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Folio de
                                            Registro:</p>
                                    </td>
                                </tr>
                                <tr style="height:15pt">
                                    <td style="width:388pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="3">
                                        <p class="s3"
                                            style="padding-top: 3pt;padding-left: 3pt;text-indent: 0pt;text-align: left;">
                                            EL OBLIGADO SOLIDARIO:
                                            <span class="s2">
                                                {{
                                                    `
                                                    ${store.form.prospects?.legalRepresentative?.firstName || ''}
                                                    ${store.form.prospects?.legalRepresentative?.lastName || ''}
                                                    ${store.form.prospects?.legalRepresentative?.mothersMaidenName || ''}
                                                    `
                                                }}
                                            </span>
                                        </p>
                                    </td>
                                    <td style="width:144pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 3pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            RFC: <span class="s2">{{ store.form.prospects?.legalRepresentative?.rfc || '' }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            CURP: <span class="s2">{{ store.form.prospects?.legalRepresentative?.curp || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:399pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="4">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Fecha y Lugar de Nacimiento / No. y Fecha Acta Constitutiva:
                                            <span class="s2">
                                                {{ 
                                                    `
                                                        ${store.form.prospects?.legalRepresentative?.dateOfBirth || ''}
                                                        ${store.form.prospects?.legalRepresentative?.birthState || ''}
                                                    `
                                                }}
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:388pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="3">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Nombre del Representante Legal:
                                            <span class="s2">
                                                {{
                                                    `
                                                        ${store.form.prospects?.legalRepresentative?.firstName || ''}
                                                        ${store.form.prospects?.legalRepresentative?.lastName || ''}
                                                        ${store.form.prospects?.legalRepresentative?.mothersMaidenName || ''}
                                                    `
                                                }}
                                            </span>
                                        </p>
                                    </td>
                                    <td style="width:144pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            RFC: <span class="s2">{{ store.form.prospects?.legalRepresentative?.rfc || '' }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            CURP: <span class="s2">{{ store.form.prospects?.legalRepresentative?.curp || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:180pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Teléfono:
                                            <span class="s2">
                                                {{
                                                    `
                                                        ${store.form.prospects?.legalRepresentative?.cellPhone || ''}
                                                        ${store.form.prospects?.legalRepresentative?.homePhone || ''}
                                                        ${store.form.prospects?.legalRepresentative?.officePhone || ''}
                                                    `
                                                }}
                                            </span>
                                        </p>
                                    </td>
                                    <td style="width:219pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Correo Electrónico: <span class="s2">{{ store.form.prospects?.legalRepresentative?.email || '' }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            No. De Poder:
                                        </p>
                                    </td>
                                    <td style="width:180pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Fecha del Poder:
                                        </p>
                                    </td>
                                    <td style="width:219pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Folio y Fecha de Registro:
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s2"
                                            style="padding-top: 2pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Número y Nombre del Notario:
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:18pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s2"
                                            style="padding-top: 4pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Domicilio:
                                            <span class="s2">
                                                {{
                                                    `
                                                        ${store.form.prospects?.addressLegalRepresentative?.street || ''}
                                                        ${store.form.prospects?.addressLegalRepresentative?.exteriorNumber || ''}
                                                        ${store.form.prospects?.addressLegalRepresentative?.interiorNumber || ''}
                                                        ${store.form.prospects?.addressLegalRepresentative?.district || ''}
                                                    `
                                                }}
                                            </span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:65pt">
                                    <td style="width:133pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        rowspan="2">
                                        <p class="s3"
                                            style="padding-left: 37pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Tasa de Interés Anual *
                                        </p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Capital
                                            <u><span class="s2">{{ (store.form.quotations?.annualRateWithVat * 100).toFixed(2) + "%" || '' }}</span></u>% más IVA
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 1pt;padding-right: 8pt;text-indent: 0pt;line-height: 163%;text-align: left;">
                                            Seguro Vida/Desempleo <span class="s5">00 </span>% más IVA Seguro de Auto
                                            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>%
                                            más
                                            IVA
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 1pt;text-indent: 0pt;line-height: 107%;text-align: left;">
                                            *
                                            Interés
                                            Ordinario tasa fija sobre saldos insolutos</p>
                                    </td>
                                    <td style="width:135pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        rowspan="2">
                                        <p class="s3"
                                            style="padding-left: 40pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Interés
                                            Moratorio</p>
                                        <p class="s2" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Capital
                                            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u>% más IVA
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 1pt;text-indent: 0pt;line-height: 157%;text-align: left;">
                                            Seguro Vida/Desempleo <span class="s5">00 </span>% más IVA Seguro de Auto
                                            <span class="s5">00
                                            </span>% más IVA
                                        </p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            * Tasa
                                            fija
                                            sobre el importe del saldo vencido</p>
                                    </td>
                                    <td
                                        style="width:120pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3" style="padding-left: 27pt;text-indent: 0pt;text-align: left;">CAT
                                            (Costo Anual Total)*
                                        </p>
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-right: 11pt;text-indent: 0pt;text-align: center;">
                                            <u>
                                                &nbsp;&nbsp;&nbsp;&nbsp; </u>%
                                        </p>
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            *
                                            Calculado
                                            al<u> &nbsp;&nbsp;&nbsp; </u> de</p>
                                        <p style="text-indent: 0pt;text-align: left;"></p>
                                        <p class="s2"
                                            style="padding-left: 63pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            de 20 , <span class="s2">{{ (store.form.quotations?.apr * 100).toFixed(2) + "%" || '' }}</span>
                                            sin
                                            IVA,
                                        </p>
                                    </td>
                                    <td style="width:144pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p style="text-indent: 0pt;text-align: left;"></p>
                                        <p class="s3"
                                            style="padding-left: 32pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Comisiones
                                            / Penalizaciones</p>
                                        <p class="s2" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Apertura (1) <span class="s2">{{ (store.form.quotations?.openingCommission * 100).toFixed(2) + "%" || '' }}</span> %
                                        </p>
                                        <p class="s2"
                                            style="padding-top: 4pt;padding-left: 2pt;padding-right: 17pt;text-indent: 0pt;line-height: 157%;text-align: left;">
                                            Pago Tardío (2) $<u>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </u> Inactividad (3)
                                            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </u>% Anualidad (4) $
                                            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:10pt">
                                    <td
                                        style="width:120pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 7pt;text-align: left;">
                                            para
                                            fines
                                            informativos y de comparación.</p>
                                    </td>
                                    <td
                                        style="width:69pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt">
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 7pt;text-align: left;">
                                            Manejo
                                            de
                                            Cuenta (5)</p>
                                    </td>
                                    <td
                                        style="width:75pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt">
                                        <p class="s2"
                                            style="padding-left: 7pt;text-indent: 0pt;line-height: 7pt;text-align: left;">
                                            $
                                            <u>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</u>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:36pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3"
                                            style="padding-left: 42pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Monto del Contrato
                                        </p>
                                        <p class="s2" style="padding-left: 16pt;text-indent: 0pt;text-align: left;">
                                            $ <span class="s2">{{ store.form.quotations?.creditAmount || '' }}</span>
                                        </p>
                                    </td>
                                    <td
                                        style="width:135pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3" style="padding-left: 38pt;text-indent: 0pt;text-align: left;">
                                            Plazo del
                                            Contrato*</p>
                                        <p style="padding-top: 5pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">*
                                            Vigencia del
                                            Contrato
                                        </p>
                                    </td>
                                    <td
                                        style="width:120pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3" style="padding-left: 41pt;text-indent: 0pt;text-align: left;">
                                            Fecha de Pago
                                        </p>
                                    </td>
                                    <td style="width:144pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s3" style="padding-left: 3pt;text-indent: 0pt;text-align: center;">
                                            Fecha de Corte
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:9pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s3" style="padding-left: 3pt;text-indent: 0pt;line-height: 7pt;text-align: center;">
                                            Entrega del Recurso
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:268pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Institución Financiera:  <span class="s2">{{ store.form.loanApplications?.directDebits?.bank || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:264pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="3">
                                        <p class="s2"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Nombre del Cuentahabiente:</p> <span class="s2">{{ store.form.loanApplications?.directDebits?.authorizedPersonName || '' }}</span>
                                    </td>
                                </tr>
                                <tr style="height:19pt">
                                    <td style="width:268pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2" style="padding-left: 4pt;text-indent: 0pt;text-align: left;">No. De Cuenta: <span class="s2">{{ store.form.loanApplications?.directDebits?.accountNumber || '' }}</span>
                                        </p>
                                    </td>
                                    <td style="width:264pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="3">
                                        <p class="s2" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Cuenta Clabe: <span class="s2">{{ store.form.loanApplications?.directDebits?.clabe || '' }}</span>
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:13pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s3"
                                            style="padding-left: 3pt;text-indent: 0pt;line-height: 8pt;text-align: center;">
                                            Información del Plástico</p>
                                    </td>
                                </tr>
                                <tr style="height:12pt">
                                    <td style="width:268pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-left: 1pt;text-indent: 0pt;line-height: 7pt;text-align: left;">
                                            Número:
                                        </p>
                                    </td>
                                    <td style="width:264pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="3">
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 7pt;text-align: left;">
                                            Fecha de
                                            Vencimiento:</p>
                                    </td>
                                </tr>
                                <tr style="height:8pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s2"
                                            style="padding-left: 1pt;text-indent: 0pt;line-height: 7pt;text-align: left;">
                                            Institución
                                            Emisora y Comercializadora de la Tarjeta:</p>
                                    </td>
                                </tr>
                                <!-- #region Este elemento se paso abajo porque ya no daba en esta pagina codigo origen , medidas de origen -->
                                <!-- <tr style="height:9pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="5">
                                        <p class="s3"
                                            style="padding-left: 3pt;text-indent: 0pt;line-height: 7pt;text-align: center;">
                                            Seguros
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:162pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3"
                                            style="padding-top: 3pt;padding-left: 8pt;text-indent: 0pt;text-align: center;">
                                            Desempleo
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 1pt;padding-right: 82pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Aseguradora: Cobertura:</p>
                                        <p class="s2" style="padding-right: 113pt;text-indent: 0pt;text-align: left;">
                                            No. Póliza:
                                        </p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 1pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Vigencia</p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">:</p>
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2"
                                            style="padding-left: 1pt;padding-right: 82pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Prima Total: Prima Anual:</p>
                                        <p class="s2"
                                            style="padding-left: 1pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Tipo de
                                            Pago:</p>
                                        <p class="s2"
                                            style="padding-right: 38pt;text-indent: 0pt;line-height: 16pt;text-align: left;">
                                            Tasa
                                            de
                                            Interés Anual: Beneficiario:</p>
                                    </td>
                                    <td
                                        style="width:135pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3"
                                            style="padding-top: 3pt;padding-right: 2pt;text-indent: 0pt;text-align: center;">
                                            Vida
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 84pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Aseguradora: Cobertura:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 84pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            No. Póliza: Vigencia:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 84pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Prima Total: Prima Anual:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Tipo de
                                            Pago:</p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 3pt;padding-right: 39pt;text-indent: -1pt;line-height: 198%;text-align: left;">
                                            Tasa de Interés Anual: Beneficiario<span class="s6">:</span></p>
                                    </td>
                                    <td
                                        style="width:120pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3"
                                            style="padding-left: 12pt;padding-right: 11pt;text-indent: 0pt;line-height: 8pt;text-align: center;">
                                            Auto</p>
                                        <p class="s2"
                                            style="padding-right: 70pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Aseguradora: Cobertura: No.Póliza: Vigencia:</p>
                                        <p class="s2"
                                            style="padding-left: 1pt;padding-right: 70pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Prima Total: Prima Anual:</p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">Tipo
                                            de Pago:</p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 1pt;padding-right: 25pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Tasa de Interés anual: Beneficiario:</p>
                                    </td>
                                    <td style="width:144pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s3"
                                            style="padding-top: 3pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;text-align: center;">
                                            Inmueble</p>
                                        <p style="padding-top: 3pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 90pt;text-indent: 0pt;line-height: 160%;text-align: left;">
                                            Aseguradora: Cobertura:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 90pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            No. Póliza: Vigencia:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 88pt;text-indent: 0pt;line-height: 160%;text-align: left;">
                                            Prima Total: Prima Anual:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Tipo de
                                            Pago:</p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 2pt;padding-right: 47pt;text-indent: 0pt;line-height: 159%;text-align: left;">
                                            Tasa de Interés Anual: Beneficiario:</p>
                                    </td>
                                </tr> -->
                                <!-- #endregion Este elemento se paso abajo porque ya no daba en esta pagina codigo origen , medidas de origen -->
                            </table>
                        </div>
                    </div>
                </div>
            </div>

            <!-- Segunda página (se forzará un salto de página aquí) -->
            <div class="page-break"></div>

            <!-- Segunda página (se forzará un salto de página aquí) -->
            <div class="page">
                <!-- Contenido de la segunda página aquí -->
                <div class="container-fluid">
                    <div class="row">
                        <div class="col-12">
                            <p style="text-indent: 0pt;text-align: left;"><br /></p>
                            <table class="table-cover web-mode" cellspacing="0">
                                <!-- #region Pase este elemento aqui porque en la hoja de arriba ya no daba y tuve que ajustar medidas-->
                                <tr style="height:9pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="4">
                                        <p class="s3"
                                            style="padding-left: 3pt;text-indent: 0pt;line-height: 7pt;text-align: center;">
                                            Seguros
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:162pt">
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3"
                                            style="padding-top: 3pt;padding-left: 8pt;text-indent: 0pt;text-align: center;">
                                            Desempleo
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 1pt;padding-right: 82pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Aseguradora: Cobertura:</p>
                                        <p class="s2" style="padding-right: 113pt;text-indent: 0pt;text-align: left;">
                                            No. Póliza:
                                        </p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 1pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Vigencia</p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">:</p>
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2"
                                            style="padding-left: 1pt;padding-right: 82pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Prima Total: Prima Anual:</p>
                                        <p class="s2"
                                            style="padding-left: 1pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Tipo de
                                            Pago:</p>
                                        <p class="s2"
                                            style="padding-right: 38pt;text-indent: 0pt;line-height: 16pt;text-align: left;">
                                            Tasa
                                            de
                                            Interés Anual: Beneficiario:</p>
                                    </td>
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3"
                                            style="padding-top: 3pt;padding-right: 2pt;text-indent: 0pt;text-align: center;">
                                            Vida
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 84pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Aseguradora: Cobertura:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 84pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            No. Póliza: Vigencia:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 84pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Prima Total: Prima Anual:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Tipo de
                                            Pago:</p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 3pt;padding-right: 39pt;text-indent: -1pt;line-height: 198%;text-align: left;">
                                            Tasa de Interés Anual: Beneficiario<span class="s6">:</span></p>
                                    </td>
                                    <td
                                        style="width:133pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:1pt">
                                        <p class="s3"
                                            style="padding-left: 12pt;padding-right: 11pt;text-indent: 0pt;line-height: 8pt;text-align: center;">
                                            Auto</p>
                                        <p class="s2"
                                            style="padding-right: 70pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Aseguradora: Cobertura: No.Póliza: Vigencia:</p>
                                        <p class="s2"
                                            style="padding-left: 1pt;padding-right: 70pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Prima Total: Prima Anual:</p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">Tipo
                                            de Pago:</p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 1pt;padding-right: 25pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            Tasa de Interés anual: Beneficiario:</p>
                                    </td>
                                    <td style="width:120pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:2pt">
                                        <p class="s3"
                                            style="padding-top: 3pt;padding-left: 3pt;padding-right: 2pt;text-indent: 0pt;text-align: center;">
                                            Inmueble</p>
                                        <p style="padding-top: 3pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 90pt;text-indent: 0pt;line-height: 160%;text-align: left;">
                                            Aseguradora: Cobertura:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 90pt;text-indent: 0pt;line-height: 200%;text-align: left;">
                                            No. Póliza: Vigencia:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 88pt;text-indent: 0pt;line-height: 160%;text-align: left;">
                                            Prima Total: Prima Anual:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Tipo de
                                            Pago:</p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 2pt;padding-right: 47pt;text-indent: 0pt;line-height: 159%;text-align: left;">
                                            Tasa de Interés Anual: Beneficiario:</p>
                                    </td>
                                </tr>
                                <!-- #endregion Pase este elemento aqui porque en la hoja de arriba ya no daba y tuve que ajustar medidas-->

                                <tr style="height:12pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="4">
                                        <p class="s2"
                                            style="padding-top: 2pt;padding-left: 3pt;padding-right: 1pt;text-indent: 0pt;line-height: 8pt;text-align: center;">
                                            El Acreditado reconoce que la aseguradora contratada fue a su libre
                                            elección.</p>
                                    </td>
                                </tr>
                                <tr style="height:9pt">
                                    <td style="width:532pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="4">
                                        <p class="s3"
                                            style="padding-left: 3pt;text-indent: 0pt;line-height: 7pt;text-align: center;">
                                            Garantía(s)</p>
                                    </td>
                                </tr>
                                <tr style="height:9pt">
                                    <td style="width:266pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s3"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: center;">
                                            Auto
                                        </p>
                                    </td>
                                    <td
                                        style="width:266pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt" colspan="2">
                                        <p class="s3"
                                            style="padding-left: 3pt;text-indent: 0pt;line-height: 8pt;text-align: center;">
                                            Bien
                                            Inmueble</p>
                                    </td>
                                </tr>
                                <tr style="height:16pt">
                                    <td
                                        style="width:100pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt" colspan="1">
                                        <p class="s7"
                                            style="padding-top: 4pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Marca:
                                        </p>
                                    </td>
                                    <td
                                        style="width:168pt;border-top-style:solid;border-top-width:1pt;border-right-style:solid;border-right-width:1pt" colspan="1">
                                        <p class="s7"
                                            style="padding-top: 4pt;padding-left: 40pt;text-indent: 0pt;text-align: left;">
                                            Destino:
                                        </p>
                                    </td>
                                    <td
                                        style="width:264pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:2pt" colspan="2">
                                        <p class="s7"
                                            style="padding-top: 4pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Domicilio:
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:13pt">
                                    <td style="width:100pt;border-left-style:solid;border-left-width:2pt" colspan="1">
                                        <p class="s7"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Sub
                                            Marca:
                                        </p>
                                    </td>
                                    <td style="width:168pt;border-right-style:solid;border-right-width:1pt" colspan="1">
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                    </td>
                                    <td
                                        style="width:264pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:2pt" colspan="2">
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                    </td>
                                </tr>
                                <tr style="height:14pt">
                                    <td style="width:100pt;border-left-style:solid;border-left-width:2pt" colspan="1">
                                        <p class="s7"
                                            style="padding-top: 2pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Modelo:
                                        </p>
                                    </td>
                                    <td style="width:168pt;border-right-style:solid;border-right-width:1pt" colspan="1">
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                    </td>
                                    <td
                                        style="width:264pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:2pt" colspan="2">
                                        <p class="s7"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Escritura:
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:13pt">
                                    <td style="width:100pt;border-left-style:solid;border-left-width:2pt" colspan="1">
                                        <p class="s7"
                                            style="padding-top: 1pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            No. De
                                            Serie:</p>
                                    </td>
                                    <td style="width:168pt;border-right-style:solid;border-right-width:1pt" colspan="1">
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                    </td>
                                    <td
                                        style="width:264pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:2pt" colspan="2">
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                    </td>
                                </tr>
                                <tr style="height:14pt">
                                    <td style="width:100pt;border-left-style:solid;border-left-width:2pt" colspan="1">
                                        <p class="s7"
                                            style="padding-top: 2pt;padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            No. De
                                            Motor:</p>
                                    </td>
                                    <td style="width:168pt;border-right-style:solid;border-right-width:1pt" colspan="1">
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                    </td>
                                    <td
                                        style="width:264pt;border-left-style:solid;border-left-width:1pt;border-right-style:solid;border-right-width:2pt" colspan="2">
                                        <p class="s7"
                                            style="padding-top: 1pt;padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Características</p>
                                    </td>
                                </tr>
                                <tr style="height:42pt">
                                    <td
                                        style="width:100pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt" colspan="1">
                                        <p class="s7"
                                            style="padding-top: 1pt;padding-left: 2pt;padding-right: 23pt;text-indent: 0pt;line-height: 147%;text-align: left;">
                                            Número de factura: Placas:</p>
                                    </td>
                                    <td
                                        style="width:168pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt" colspan="1">
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                    </td>
                                    <td
                                        style="width:264pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt" colspan="2">
                                        <p style="padding-top: 5pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s7" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Hipoteca:</p>
                                    </td>
                                </tr>
                            </table>
                            <p style="text-indent: 0pt;text-align: left;"><br /></p>
                        </div>
                    </div>
                </div>

            </div>

            <!-- Segunda página (se forzará un salto de página aquí) -->
            <div class="page-break"></div>

            <div class="page">
                <!-- Contenido de la tercera página aquí -->
                <div class="container-fluid" style="padding-top: 10px;">
                    <div class="row">
                        <div class="col-3">
                            <img width="100" height="51" src="/img/LOGOTIPOGOLDERGFUND.jpg" />
                        </div>
                        <div class="col-6 form-header-cover">
                            <div class="form-group row">
                                <label for="numContract" class="col-form-label label-form-cover">Número de contrato:</label>
                                <div>
                                    <input type="text" class="form-control underline-input-cover" :value="store.form.products?.productContract?.referenceNumber" disabled/>
                                </div>
                            </div>
                            <div class="form-group row">
                                <label for="numAcredit" class="col-form-label label-form-cover">Número de Acreditado:</label>
                                <div>
                                    <input type="text" class="form-control underline-input-cover" :value="store.form.prospects?.referenceNumber" disabled/>
                                </div>
                            </div>
                        </div>
                        <div class="col-3 text-right">
                            <p>Anexo “A”</p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-6 title-anexo-cover">
                            <p>CARÁTULA DEL CONTRATO</p>
                        </div>
                        <div class="col-6"></div>
                    </div>
                    <div class="row">
                        <div class="col-12">
                            <table class="table-cover web-mode" cellspacing="0">
                                <tr style="height:9pt">
                                    <td style="width:531pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="4">
                                        <p class="s3"
                                            style="padding-left: 3pt;text-indent: 0pt;line-height: 7pt;text-align: center;">
                                            Pagos
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:8pt">
                                    <td style="width:267pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s3"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 6pt;text-align: center;">
                                            Ventanilla
                                            Bancaria</p>
                                    </td>
                                    <td style="width:264pt;border-top-style:solid;border-top-width:2pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s3"
                                            style="padding-left: 58pt;text-indent: 0pt;line-height: 6pt;text-align: left;">
                                            Pago
                                            Domiciliado</p>
                                    </td>
                                </tr>
                                <tr style="height:101pt">
                                    <td style="width:267pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:1pt"
                                        colspan="2">
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Beneficiario:
                                            Días:</p>
                                        <p class="s2"
                                            style="padding-top: 7pt;padding-left: 1pt;padding-right: 216pt;text-indent: 0pt;line-height: 209%;text-align: left;">
                                            Institución: Financiera: Convenio CIE: Referencia: Monto:</p>
                                    </td>
                                    <td style="width:264pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="2">
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 132pt;text-indent: 0pt;line-height: 204%;text-align: left;">
                                            Titular de la Cuenta (EL ACREDITADO): Institución:</p>
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Cuenta:
                                        </p>
                                        <p style="padding-top: 1pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Cuenta Clabe:</p>
                                        <p style="padding-top: 1pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">Monto
                                            Máximo
                                            Autorizado:
                                        </p>
                                        <p style="padding-top: 1pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            Días:
                                        </p>
                                        <p class="s3" style="padding-left: 102pt;text-indent: 0pt;text-align: left;">
                                            Firma de
                                            Autorización
                                        </p>
                                    </td>
                                </tr>
                                <tr style="height:98pt">
                                    <td style="width:531pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:1pt;border-right-style:solid;border-right-width:2pt"
                                        colspan="4">
                                        <p class="s2"
                                            style="padding-top: 5pt;padding-left: 6pt;padding-right: 5pt;text-indent: 0pt;line-height: 111%;text-align: justify;">
                                            Una vez leídos los documentos relativos al “CONTRATO”, EL ACREDITADO y EL
                                            OBLIGADO
                                            SOLIDARIO
                                            declaran estar plenamente conscientes de los términos y condiciones
                                            previstos en la
                                            presente
                                            Carátula del “CONTRATO”, misma que en este acto ratifican para todos los
                                            efectos legales
                                            a que
                                            haya
                                            lugar. Las personas que comparecen en el carácter de EL ACREDITADO y/o EL
                                            OBLIGADO
                                            SOLIDARIO
                                            manifiestan que es su voluntad constituirse como tal y en consecuencia
                                            obligarse frente
                                            a
                                            GOLDBERGFUND respecto del cumplimiento de todas y cada una de las
                                            obligaciones a cargo
                                            de EL
                                            ACREDITADO de conformidad con los términos y condiciones del “CONTRATO”,
                                            Carátula y sus
                                            Anexos.
                                        </p>
                                        <p style="padding-top: 6pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 49pt;text-indent: 0pt;text-align: left;">
                                            Enteradas de su
                                            contenido y
                                            alcance legal, las partes celebran el presente “CONTRATO”, por duplicado,
                                            entregándose
                                            uno a EL
                                            ACREDITADO en la ciudad de</p>
                                        <p class="s2" style="padding-left: 30pt;text-indent: 0pt;text-align: left;"><u>
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </u> <u>&nbsp;,
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </u> <u>&nbsp;,
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </u> <u>al &nbsp;&nbsp;&nbsp;&nbsp;&nbsp; </u> d<u>e
                                                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            </u> de 2<u> 0 </u><span class="s9">_&nbsp;&nbsp;</span></p>
                                    </td>
                                </tr>
                                <tr style="height:122pt">
                                    <td
                                        style="width:138pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:2pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt">
                                        <p style="padding-top: 5pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 47pt;text-indent: 0pt;text-align: left;">EL
                                            ACREDITADO
                                        </p>
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                        <p
                                            style="padding-left: 9pt;text-indent: 0pt;line-height: 1pt;text-align: left;">
                                        </p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Nombre: <span class="s2">{{ nameAccredited || '' }}</span>
                                        </p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Identificación:
                                            <span class="s10">{{ store.form?.prospects?.generalInformation?.identificationType || '' }}</span>
                                        </p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">No.
                                            De Identificación: <span class="s2">{{ store.form?.prospects?.generalInformation?.identificationNumber || ''  }}</span>
                                        </p>
                                    </td>
                                    <td
                                        style="width:129pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt">
                                        <p style="padding-top: 5pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 31pt;text-indent: 0pt;text-align: left;">
                                            EL OBLIGADO SOLIDARIO
                                        </p>
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                        <p
                                            style="padding-left: 9pt;text-indent: 0pt;line-height: 1pt;text-align: left;">
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 2pt;padding-right: 69pt;text-indent: 0pt;line-height: 106%;text-align: left;">
                                            Nombre: 
                                            <span class="s2">
                                                {{ store.form.prospects?.legalRepresentative?.firstName || '' }}
                                                {{ store.form.prospects?.legalRepresentative?.lastName || '' }}
                                                {{ store.form.prospects?.legalRepresentative?.mothersMaidenName || '' }}
                                            </span>
                                        </p>
                                        <p class="s2" style="padding-left: 1pt;text-indent: 0pt;text-align: left;">
                                            Identificación:
                                            <span class="s2">{{store.form?.prospects?.legalRepresentative?.identificationType || ''}}</span>
                                        </p>
                                        <p class="s2"
                                            style="padding-left: 2pt;text-indent: 0pt;line-height: 8pt;text-align: left;">
                                            No. De Identificación:
                                            <span class="s2">{{store.form?.prospects?.legalRepresentative?.identificationNumber || '' }}</span>
                                        </p>
                                    </td>
                                    <td
                                        style="width:122pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:1pt">
                                        <p style="padding-top: 5pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 38pt;text-indent: 0pt;text-align: left;">
                                            GOLDBERGFUND</p>
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                        <p
                                            style="padding-left: 10pt;text-indent: 0pt;line-height: 1pt;text-align: left;" />
                                        <p class="s2" style="padding-left: 40pt;text-indent: 0pt;text-align: left;">
                                            Autorizado por:
                                        </p>
                                        <p style="padding-top: 1pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 2pt;text-indent: 0pt;text-align: left;">
                                            Puesto:</p>
                                    </td>
                                    <td
                                        style="width:142pt;border-top-style:solid;border-top-width:1pt;border-left-style:solid;border-left-width:1pt;border-bottom-style:solid;border-bottom-width:2pt;border-right-style:solid;border-right-width:2pt">
                                        <p style="padding-top: 5pt;text-indent: 0pt;text-align: left;"><br /></p>
                                        <p class="s2" style="padding-left: 3pt;text-indent: 0pt;text-align: center;">
                                            GOLDBERGFUND
                                        </p>
                                        <p style="text-indent: 0pt;text-align: left;"><br /></p>
                                        <p
                                            style="padding-left: 9pt;text-indent: 0pt;line-height: 1pt;text-align: left;" />
                                        <p class="s2"
                                            style="padding-left: 3pt;padding-right: 1pt;text-indent: 0pt;text-align: center;">
                                            Representante Legal</p>
                                    </td>
                                </tr>
                            </table>
                            <p style="text-indent: 0pt;text-align: left;"><br /></p>
                            <ol id="l1">
                                <li data-list-text="(1)">
                                    <p style="padding-left: 15pt;text-indent: -8pt;text-align: left;">Se cobrará al
                                        momento de la
                                        firma del
                                        contrato calculándose sobre el importe autorizado (monto del contrato).</p>
                                </li>
                                <li data-list-text="(2)">
                                    <p style="padding-left: 15pt;text-indent: -8pt;text-align: left;">Importe que
                                        GOLDBERGFUND
                                        cargará al
                                        ACREDITADO el segundo día hábil que su cuenta refleje falta de pago.</p>
                                </li>
                                <li data-list-text="(3)">
                                    <p style="padding-left: 6pt;text-indent: 0pt;line-height: 112%;text-align: left;">
                                        Aplica si EL
                                        ACREDITADO no
                                        usa por lo menos el 20% de su línea autorizada en un periodo de un mes.
                                        Resultando de
                                        multiplicar el
                                        porcentaje señalado por el importe autorizado (monto del contrato).</p>
                                </li>
                                <li data-list-text="(4)">
                                    <p style="padding-left: 15pt;text-indent: -8pt;line-height: 8pt;text-align: left;">
                                        Pago anual
                                        que el
                                        ACREDITADO realizará por el derecho de tener un <span
                                            style=" color: #F00;">crédito
                                        </span>con
                                        GOLDBERGFUND.</p>
                                </li>
                                <li data-list-text="(5)">
                                    <p style="padding-left: 6pt;text-indent: 0pt;line-height: 110%;text-align: left;">
                                        Pago mensual
                                        que EL
                                        ACREDITADO deberá liquidar a GOLDBERGFUND por la administración del <span
                                            style=" color: #F00;">crédito
                                        </span>otorgado. Resultando de multiplicar el porcentaje señalado por el importe
                                        autorizado
                                        (monto
                                        del
                                        contrato).</p>
                                </li>
                            </ol>
                            <p style="text-indent: 0pt;text-align: left;"><br /></p>
                            <h1 style="padding-left: 6pt;text-indent: 0pt;text-align: left;">Advertencias</h1>
                            <ol id="l2">
                                <li data-list-text="1.">
                                    <p style="padding-left: 11pt;text-indent: -5pt;text-align: left;">‐ Incumplir con
                                        las
                                        obligaciones de
                                        pago
                                        puede generar comisiones e intereses moratorios.</p>
                                </li>
                                <li data-list-text="2.">
                                    <p style="padding-left: 11pt;text-indent: -5pt;text-align: left;">‐ Obligarse a
                                        pagos que
                                        excedan su
                                        capacidad de pago, puede ocasionar incumplimiento afectando su historial
                                        crediticio.</p>
                                </li>
                                <li data-list-text="3.">
                                    <p style="padding-left: 11pt;text-indent: -5pt;text-align: left;">‐ El Obligado
                                        solidario o
                                        aval,
                                        responderá
                                        como obligado principal por el total del pago frente a GOLDBERGFUND.</p>
                                </li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="form-actions">
            <button class="download-btn">Descargar PDF</button>
        </div>
    </form>
</template>

<script setup>
import { ref, onMounted, computed, getCurrentInstance } from 'vue';
import { useContractCoverStore } from '@/pinia/LoanApplications/Legal/useContractCoverStore.module';

const store = useContractCoverStore();
const contractContent = ref(null);

const nameAccredited = computed({
    get: () => {
        if (store.form.prospects?.generalInformation.businessName === null) {
            return `${store.form.prospects?.generalInformation?.firstName || ''} ${store.form.prospects?.generalInformation?.lastName || ''} ${store.form.prospects?.generalInformation?.mothersMaidenName || ''}`;
        } else {
            return store.form.prospects?.generalInformation?.businessName || '';
        }
    }
});

const date_place_birth_num_date_institute = computed({
    get: () => {
        if (store.form.prospects?.generalInformation?.dateOfIncorporation === null) {
            return `${store.form.prospects?.generalInformation?.dateOfBirth || ''} ${store.form.prospects?.generalInformation?.birthState || ''} ${store.form.prospects?.generalInformation?.birthCountry || ''}`;
        } else {
            return `${store.form.prospects?.generalInformation?.dateOfIncorporation || ''}`;
        }
    }
});

const handleSubmit = () => {
    store.saveData();
};

onMounted(() => {
    store.setContractContent(contractContent.value);
});
</script>

<style scoped>
* {
    margin: 0;
    padding: 0;
    text-indent: 0;
}

#content-to-pdf {
    
    overflow: visible;
    /*!important Permite que el desborde sea visible */
    font-family: Calibri, sans-serif;
    color: #000 !important;
}

.pdf-container.web-container-mode * {
    font-size: 12px !important;
}

/* Clase para forzar salto de página */
.page-break {
    page-break-after: always;
    break-after: page;
    height: 0;
    visibility: hidden;
}

/* Clase para evitar que se divida el contenido en páginas */
.page {
    padding: 20px;
    background-color: white;
    box-shadow: 0 0 8px rgba(0, 0, 0, 0.2);
    page-break-inside: avoid;
    margin-bottom: 25px;
}

.pdf-mode .page {
    box-shadow: none;
    background-color: white;
    padding: 0;
    margin: 0;
}

/** Estilo contenido del formulario */
p {
    color: black;
    font-family: Calibri, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 6.5pt;
    margin: 0pt;
}

.s1 {
    color: #F00;
    font-family: Calibri, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 6.5pt;
}

.s2 {
    color: black;
    font-family: Calibri, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 6.5pt;
}

.s3 {
    color: black;
    font-family: Calibri, sans-serif;
    font-style: normal;
    font-weight: bold;
    text-decoration: none;
    font-size: 6.5pt;
}

.s5 {
    color: black;
    font-family: Arial, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 5.5pt;
}

.s6 {
    color: black;
    font-family: "Segoe UI Emoji", sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 6.5pt;
}

.s7 {
    color: black;
    font-family: Calibri, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 7pt;
}

.s8 {
    color: black;
    font-family: Arial, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 6pt;
}

.s9 {
    color: black;
    font-family: Arial, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: underline;
    font-size: 6.5pt;
}

.s10 {
    color: #F00;
    font-family: Arial, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 5.5pt;
}

h1 {
    color: black;
    font-family: Calibri, sans-serif;
    font-style: normal;
    font-weight: bold;
    text-decoration: none;
    font-size: 6.5pt;
}

li {
    display: block;
}

#l1 {
    padding-left: 0pt;
    counter-reset: c1 1;
}

#l1>li>*:first-child:before {
    counter-increment: c1;
    content: "(" counter(c1, decimal)") ";
    color: black;
    font-family: Calibri, sans-serif;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
    font-size: 6.5pt;
}

#l1>li:first-child>*:first-child:before {
    counter-increment: c1 0;
}

li {
    display: block;
}

#l2 {
    padding-left: 0pt;
    counter-reset: d1 1;
}

#l2>li>*:first-child:before {
    counter-increment: d1;
    content: counter(d1, decimal)". ";
    color: black;
    font-style: normal;
    font-weight: normal;
    text-decoration: none;
}

#l2>li:first-child>*:first-child:before {
    counter-increment: d1 0;
}

table,
tbody {
    vertical-align: top;
    overflow: visible;
}

/**Descarga */
.download-btn {
    padding: 10px 20px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 20px;
    transition: background-color 0.3s;
}

.download-btn:hover {
    background-color: #369f6e;
}

/**Inputs del formulamario */
.form-inline {
    display: flex;
    flex-flow: row wrap;
    align-items: center;
}

.form-inline .form-group,
.form-inline .form-check {
    margin-right: 1rem;
    margin-bottom: 0;
}

.form-inline .form-control {
    display: inline-block;
    width: auto;
    vertical-align: middle;
}

.form-header-cover {
    padding-left: 160px;
}

.pdf-mode .form-header-cover {
    padding-left: 20.2px;
}

.form-header-cover .form-group.row {
    font-size: 12px;
    height: 28px;
}

.pdf-mode .form-header-cover .form-group.row {
    height: 20px;
}

.label-form-cover {
    align-content: end;
}

.underline-input-cover {
    border: 0px;
    background: transparent;
    border-bottom: 1px solid #000;
    border-radius: 0px;
    margin-left: 8px;
    padding-top: 20px;
    /*font-family: "Calibri Light", Calibri, "Gill Sans", "Gill Sans MT", sans-serif;*/
    font-family: Calibri, sans-serif;
    font-size: 12px;
    color: #000;
}

.title-anexo-cover {
    padding-left: 260px;
}

.pdf-mode .title-anexo-cover {
    padding-left: 240px !important;
}

.title-anexo-cover p {
    padding-top: 15px;
    padding-bottom: 15px;
}

.pdf-mode .title-anexo-cover p {
    padding-top: 40px;
    padding-bottom: 20px;
}

/**Estilo de tablas */
.table-cover.web-mode {
    width: 100%;
}

.pdf-mode .table-cover {
    border-collapse: collapse !important;
    margin-left: 10px;
}

/* Estilos para el botón de descarga */
.download-btn {
    padding: 10px 20px;
    background-color: #42b983;
    color: white;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: 16px;
    margin-top: 20px;
    transition: background-color 0.3s;
}

.download-btn:hover {
    background-color: #369f6e;
}
</style>